<template>
	<div class="page page--reimbursement-list layout">
		<div class="layout__header layout__header--reimbursement-list">
			<div class="logo"></div>
			<div class="form form--top">
				<div class="form__content">
					<div class="form__group">
						<div :class="'form__input form__input--block' + (datetimeFiled === 'id' ? ' focus' : '')">
							<input type="text" @keyup="search"  v-model="id" placeholder="请输入报销ID搜素" @focus="datetimeFiled = 'id'" @click="datetimeFiled = 'id'" @blur="datetimeFiled = ''"/>
							<a href="javscript:;" v-if="datetimeFiled === 'id'" @click="datetimeFiled = ''">取消</a>
						</div>
					</div>
					<div class="form__group">
						<div class="form__select form__select--block">
							<select v-model="type" @change="search" class="reimbursement-list">
								<option value="1">一周</option>
								<option value="2">一个月</option>
								<option value="3">三个月</option>
								<option value="4">六个月</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="layout__body">
			<div class="report__tip" v-show="reportList.length > 0">
				<div v-html="remark"></div>
			</div>
			<div class="report__list" v-show="reportList.length > 0">
				<div class="report__item" v-for="(report,index) in reportList" :key="index">
					<div class="report__content">
						<div class="report__id">
							<div class="report__label">报销ID</div>
							<div class="report__con">{{report.report_id}}</div>
						</div>
						<div class="report__time">
							<div class="report__label">审批时间</div>
							<div class="report__con">{{report.approval_send_date}}</div>
						</div>
						<div :class="'report__status report__status--' + (report.color == 1 ? 'done' : report.color == 2 ? 'waiting' : 'none')">{{report.status}}</div>
						<!--
							* status *
							* 1: 已审批 done
							* 2: 待审批 waiting
							* 3: 系统无此记录 none
						-->
					</div>
					<div class="report__tip" v-show="report.status === '已审批'">此结果仅为报销状态查询，实际收款日以付款凭证邮件为准。</div>
				</div>
			</div>
			<div class="report__nodata" v-show="reportList.length === 0">系统无此记录</div>
		</div>
		<div class="mask mask--datetime-picker j_datetime_picker" :data-filed="datetimeFiled" v-show="showPicker || (datetimeFiled==='id')">
			<div class="datetime-picker" v-show="showPicker">
				<van-datetime-picker
					v-model="currentDate"
					type="date"
					:formatter="formatter"
					@confirm="setDate"
					@cancel="cancelSetDate"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import API from '@/api.js';
import util from '@/lib/util';
export default {
	name: 'home',
	data () {
		return {
			onceTip: false,
			showPicker: false,
			timer: null,
			currentDate: new Date(),
			lodding: false,
			remark: '',
			reportList: [],
			datetimeFiled: '',
			id: this.$route.params.id,
			type: this.$route.params.type || 1,
			pageBean: {
				page: 1,
				last_page: 1
			}
		};
	},
	computed: {
		startTimeStr () {
			let value = util.formatDate(this.start_time);
			return value;
		},
		endTimeStr () {
			let value = util.formatDate(this.end_time);
			return value;
		}
	},
	methods: {
		getReportList () {
			/* let startTime = util.formatDate(this.start_time, '-');
			let endTime = util.formatDate(this.end_time, '-'); */

			API.getReportList({ id: this.id, type: this.type, page: this.pageBean.page }).then((res) => {
				if (res.data.code === 200) {
					if (this.pageBean.page === 1) {
						this.reportList = [].concat(res.data.data.list);
					} else {
						this.reportList = this.reportList.concat(res.data.data.list);
					}
					this.remark = this.$sanitize(res.data.data.remark);
					this.pageBean.page++;
					this.pageBean.last_page = res.data.data.pagination.last_page;
				}
				this.lodding = false;
			});
			if (!this.onceTip) {
				window.scrollTo(0, 0);
				this.$msgBox.showMsgBox({ title: '温馨提示', desc: '<div>1.本数据使用WebEE系统提供的截至前一日24：00数据，每日更新一次;</div><br><div>2.目前仅同步进行中的报告，暂不呈现未提交及被退件的报告;</div>' });
				this.onceTip = true;
			}
		},
		formatter (type, value) {
			if (type === 'year') {
				return `${value}年`;
			} else if (type === 'month') {
				return `${value}月`;
			} else if (type === 'day') {
				return `${value}日`;
			}
			return value;
		},
		getScrollTop () {
			let scrollTop = 0;
			let bodyScrollTop = 0;
			let documentScrollTop = 0;
			if (document.body) {
				bodyScrollTop = document.body.scrollTop;
			}
			if (document.documentElement) {
				documentScrollTop = document.documentElement.scrollTop;
			}
			scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
			return scrollTop;
		},
		getScrollHeight () {
			let scrollHeight = 0;
			let bSH;
			let dSH;
			if (document.body) {
				bSH = document.body.scrollHeight;
			}
			if (document.documentElement) {
				dSH = document.documentElement.scrollHeight;
			}
			scrollHeight = (bSH - dSH > 0) ? bSH : dSH;
			return scrollHeight;
		},
		getWindowHeight () {
			let windowHeight = 0;
			if (document.compatMode === 'CSS1Compat') {
				windowHeight = document.documentElement.clientHeight;
			} else {
				windowHeight = document.body.clientHeight;
			}
			return windowHeight;
		},
		openDatetimePicker (field) {
			this.datetimeFiled = field;
			this.showPicker = true;
		},
		cancelSetDate () {
			this.datetimeFiled = '';
			this.showPicker = false;
		},
		setDate (value) {
			this[this.datetimeFiled] = value;
			this.showPicker = false;
			this.datetimeFiled = '';
			this.pageBean.page = 1;
			this.getReportList();
		},
		search () {
			let self = this;
			clearTimeout(self.timer);
			self.timer = setTimeout(function () {
				self.pageBean.page = 1;
				self.getReportList();
			}, 1000);
		},
		setWechat () {
			let self = this;
			API.getWechatAssign().then((res) => {
				let data = res.data.data;
				self.$wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
					timestamp: data.timestamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.signature, // 必填，签名，见附录1
					jsApiList: ['hideOptionMenu', 'showOptionMenu']
				});
				self.$wx.ready(function () {
					self.$wx.showOptionMenu();
				});
				self.$wx.showOptionMenu();
			});
		}
	},
	components: {},
	created () {},
	mounted () {
		let self = this;
		this.getReportList();
		window.onscroll = function () {
			if (!document.querySelector('.page--reimbursement-list') || self.pageBean.page > self.pageBean.last_page) {
				return;
			}
			if (self.getScrollTop() + self.getWindowHeight() === self.getScrollHeight() && !self.lodding) {
				self.lodding = true;
				self.getReportList();
			}
		};
	}
};
</script>
